/**
 * @file A currency figure: the answered decimal as exact currency text, or as
 * compact text when `compact` is set, or the figure's loading or refusal
 * through `AnalyticsUnansweredFigure`. Consumers: `AnalyticsOverviewTiles`,
 * `AnalyticsInvoicingTiles`, `HomeAnalyticsTiles` and the Orders tiles and
 * lifecycle. An unanswered figure never renders as zero.
 */
import { FC } from 'react';

import { analyticsCompactCurrencyText } from '@/analytics';
import type { AnalyticsDecimalFigure } from '@/analytics';
import { analyticsCurrencyText } from '#types';

import { AnalyticsUnansweredFigure } from './AnalyticsUnansweredFigure';

export const AnalyticsCurrencyFigure: FC<{
  figure: AnalyticsDecimalFigure;
  compact?: boolean;
}> = ({ figure, compact }) =>
  figure.status === 'answered' ? (
    <>
      {compact
        ? analyticsCompactCurrencyText(figure.decimal)
        : analyticsCurrencyText(figure.decimal)}
    </>
  ) : (
    <AnalyticsUnansweredFigure figure={figure} />
  );
